import { createFileRoute } from '@tanstack/react-router';
import ClientManagement from '../../components/manager/ClientManagement';
import ReceptionPortal from '../../components/portals/ReceptionPortal';

export const Route = createFileRoute('/reception/clients')({
  component: ReceptionClientsRoute,
});

function ReceptionClientsRoute() {
  return (
    <ReceptionPortal>
      <ClientManagement />
    </ReceptionPortal>
  );
}

